var map = {
	"./Administration/Actions.vue": 8734,
	"./Administration/Currencies.vue": 7461,
	"./Administration/Networks.vue": 8373,
	"./Administration/Settings.vue": 2564,
	"./Administration/TelegramStatistics.vue": 215,
	"./Auth/2FA.vue": 7294,
	"./Auth/2FAActivate.vue": 6886,
	"./Auth/ConfirmPassword.vue": 9975,
	"./Auth/ForgotPassword.vue": 4341,
	"./Auth/Login.vue": 8239,
	"./Auth/Register.vue": 7823,
	"./Auth/ResetPassword.vue": 5073,
	"./Auth/VerifyEmail.vue": 1740,
	"./Blockchain/Stake.vue": 3225,
	"./Blockchain/Votes.vue": 9323,
	"./Crosschain/Index.vue": 7278,
	"./Dashboard/Accounts.vue": 5215,
	"./Dashboard/Addresses.vue": 8203,
	"./Dashboard/Advanced.vue": 5281,
	"./Dashboard/AdvancedAnalytics.vue": 375,
	"./Dashboard/Users.vue": 8205,
	"./Exchanges/Index.vue": 7962,
	"./FiatGateways/Credentials.vue": 1404,
	"./FiatGateways/Currencies.vue": 4892,
	"./FiatGateways/Fields.vue": 2491,
	"./FiatGateways/Gateway.vue": 9726,
	"./FiatGateways/Gateways.vue": 3722,
	"./FiatGateways/Test.vue": 2888,
	"./OCP/Addresses.vue": 975,
	"./OCP/Blockchain.vue": 3226,
	"./OCP/Organization/Addresses.vue": 3346,
	"./OCP/Organization/Analytics.vue": 9140,
	"./OCP/Organization/Balances.vue": 3538,
	"./OCP/Organization/Exchanges.vue": 2905,
	"./OCP/Organization/Fiat.vue": 9570,
	"./OCP/Organization/Index.vue": 2804,
	"./OCP/Organization/Users.vue": 7290,
	"./OCP/Partner/Index.vue": 337,
	"./OCP/Partner/Show.vue": 2450,
	"./OCP/Referrals.vue": 9708,
	"./OCP/Statistics.vue": 794,
	"./OCP/Tariffs.vue": 1691,
	"./OCP/User/Referrals.vue": 1512,
	"./OCP/User/Sessions.vue": 1381,
	"./OCP/User/User.vue": 9806,
	"./OCP/Users.vue": 604,
	"./Orders.vue": 6778,
	"./Organizations/Index.vue": 7143,
	"./Report/Index.vue": 2140,
	"./Settings/Actions.vue": 9015,
	"./Settings/AuthorizationLog.vue": 8916,
	"./Settings/Profile.vue": 8436,
	"./Settings/Roles/Create.vue": 2860,
	"./Settings/Roles/Edit.vue": 5930,
	"./Settings/Roles/Index.vue": 5220,
	"./Settings/Users/Actions.vue": 5798,
	"./Settings/Users/Create.vue": 3068,
	"./Settings/Users/Edit.vue": 5719,
	"./Settings/Users/Index.vue": 281,
	"./Tariffs/Index.vue": 5009,
	"./Tariffs/Logs.vue": 8729,
	"./Test.vue": 2443,
	"./Transactions/Analytics.vue": 8156,
	"./Transactions/History.vue": 3924,
	"./Transactions/HistoryV3.vue": 2517,
	"./Transactions/Index.vue": 4853,
	"./Welcome.vue": 3919,
	"./Withdrawals.vue": 2697,
	"./Withdrawals/Auto.vue": 99
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1230;